import { useSearchParams } from 'react-router-dom';

import { parseSearchParams, ParseSearchParamsConfig } from '../util/url';

export const useQueriesControl = <const P extends readonly string[], C extends ParseSearchParamsConfig<P>>(params: P, config: Partial<C> = {}) => {
	const [search, setSearch] = useSearchParams();

	const queries = parseSearchParams(search, params, config);

	const onChange = <U extends Partial<{ [K in P[number]]: string | number | boolean | null }>>(value: U) => {
		Object.entries(value).forEach(([key, value]) => {
			if (!params.includes(key as any)) {
				return;
			}

			if (value === null || value === undefined) {
				search.delete(key);
			} else if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
				search.set(key, value.toString());
			}
		});

		setSearch(search);
	};

	return [queries, onChange] as const;
};

// Common transformers
export const positiveInteger = (page: string | undefined) => {
	if (!page) {
		return 1;
	}

	const parsed = parseInt(page, 10);
	return isNaN(parsed) ? 1 : Math.max(1, parsed);
};
